/**
 * Stable QR payload shared by PDF labels, PNG labels and the scanner.
 */
export function qrPayload(kind, id) {
    return `platzwart://${kind}/${id}`;
}
